import { render, staticRenderFns } from "./VersionValidate.vue?vue&type=template&id=ac233a28&scoped=true&"
import script from "./VersionValidate.vue?vue&type=script&lang=js&"
export * from "./VersionValidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac233a28",
  null
  
)

export default component.exports